import {axiosInstance, Data, OResult} from "./axios-instance";
import {downloadLinkProcessor} from "../components/hooks/FileLoader"
import {Profile} from "./user-api";

export interface Document {
    ID: number,
    TYPE1: string,
    USER_ID: number,
    TO_USER_ID: number,
    COMPANY_ID: number,
    CONTENT: string,
    ADDITIONAL_INFO: string,
    CONTENT_SIGN: string,
    NEED_CONFIRM: boolean,
    CREATED: number,
    VERSION: number,
    READY: number,
    SIGNED: number,
    REJECTED: number,
}

export interface DocumentFile {
    ID: number,
    DOCUMENT_ID: number,
    NAME: string,
    CONTENT_URL: string,
    CONTENT_SIZE: number,
    CONTENT_HASH: string,
    CREATED: number,
    VERSION: number,
}

export interface Company {
    ID: number,
    USER_ID: number,
    NAME: string,
    NAME_FULL: string,
    ADDRESS: string,
    ADDRESS_ACTUAL: string,
    CODE_INN: string,
    CODE_KPP: string,
    CODE_OGRN: string,
    EMAIL: string,
    TEL: string,
    CREATED: number,
    VERSION: number,
    CONFIRMED: number,
}

export type NalogStatusType = "NONE" | "SMZ" | "IP" | "FL";

export interface Executor {
    ID: number,
    USER_ID: number,
    NALOG_ID: string,
    NALOG_STATUS: NalogStatusType,
    NALOG_NPD: 0 | 1,
    NALOG_ALLOW_PAYMENT: boolean
    NALOG_PCT: number,
    DOCUMENT_SIGN_1_ID: number,
    DOCUMENT_SIGN_1: boolean,
    DOCUMENT_SIGN_2_ID: number,
    DOCUMENT_SIGN_2: boolean,
    DOCUMENT_SIGN_3_ID: number,
    DOCUMENT_SIGN_3: boolean,
    CREATED: number,
    VERSION: number,
    ASSIGNED: number,
}

export interface CompanyExecutor {
    ID: number,
    COMPANY_ID: number,
    EXECUTOR_ID: number,
    USER_ID: number,
    CREATED: number,
    ACCEPTED: number,
    CONFIRMED: number,
}

export type CompanyOperatorRoleType = "READ" | "EDIT" | "EDIT_AND_CONFIRM" | "OWNER";

export interface CompanyOperator {
    ID: number,
    COMPANY_ID: number,
    USER_ID: number,
    ROLE_TYPE: CompanyOperatorRoleType,
    CODE_INN: string,
    CREATED: number,
    VERSION: number,
}

export interface CompanyExecutorFull {
    ID: number,
    COMPANY_ID: number,
    EXECUTOR_ID: number,
    USER_ID: number,
    CREATED: number,
    ACCEPTED: number,
    CONFIRMED: number,
    USER_ID_OWN: number,
    NICK_NAME: string,
    FIRST_NAME: string,
    SECOND_NAME: string,
    LAST_NAME: string,
    DESCRIPTION: string,
    TEL: string,
    COUNTRY: string,
    IMAGE: string,
    SEX: number,
    DATE_OF_BIRTH: number,
    PASS_NUMBER: string,
    PASS_DATE: number,
    PASS_DEPARTMENT_CODE: string,
    PASS_DEPARTMENT: string,
    PASS_PLACE_OF_BIRTH: string,
    PASS_ADDRESS: string,
    CODE_INN: string,
    CODE_KPP: string,
    CODE_SNILS: string,
    NALOG_STATUS: string,
    NALOG_NPD: number,
    NALOG_PCT: number,
    NALOG_ALLOW_PAYMENT: boolean
    DOCUMENT_SIGN_1_ID: number,
    DOCUMENT_SIGN_1: boolean,
    DOCUMENT_SIGN_2_ID: number,
    DOCUMENT_SIGN_2: boolean,
    DOCUMENT_SIGN_3_ID: number,
    DOCUMENT_SIGN_3: boolean,
    VERSION: number,
    WITHDRAW_TYPE: string,
    WITHDRAW_SPB_TEL: string,
    WITHDRAW_SPB_TEL_BANK_ID: number,
    WITHDRAW_CARD_NUMBER: string,
    WITHDRAW_ACCOUNT_NUMBER: string,
    WITHDRAW_BIC: string,
    EMAIL: string,
}

export interface CompanyFile {
    ID: number,
    COMPANY_ID: number,
    NAME: string,
    CONTENT_URL: string,
    CONTENT_SIZE: number,
    CONTENT_HASH: string,
    CREATED: number,
    VERSION: number,
}

export interface ExecutorContract {
    ID: number,
    USER_ID: number,
    COMPANY_EXECUTOR_ID: number,
    NAME: string,
    END_DATE: number,
    DOCUMENT_ID: number,
    CREATED: number,
    VERSION: number,
    SENDED: number,
    CONFIRMED: number,
}

export type CalculationType = "TASK" | "HOUR";

export interface ExecutorTask {
    ID: number,
    EXECUTOR_CONTRACT_ID: number,
    COMPANY_EXECUTOR_ID: number,
    TYPE1: string,
    NAME: string,
    DESCRIPTION: string,
    ADDRESS: string,
    START_DATE: number,
    END_DATE: number,
    VALUE1: number,
    DOCUMENT_ID: number,
    CATEGORY: string,
    PROJECT: string,
    COMMENTS: string,
    CALCULATION_TYPE: CalculationType,
    CALCULATION_TIME_H_ESTIMATED: number,
    CALCULATION_TIME_H_ACTUAL: number,
    CALCULATION_TIME_H_VERIFIED: number,
    RESULT_VALUE: number,
    CREATED: number,
    VERSION: number,
    SENDED: number,
    ACCEPTED: number,
    AT_WORK: number,
    EXECUTED: number,
    CONFIRMED: number,
    PAID: number,
}

export interface Account {
    USER_ID: number,
    COMPANY_ID: number,
    BALANCE: number,
    COMMISSION_PAYOUT_PCT: number,
    RESERVED: number,
    BANK_ACC_NUMBER: string,
    BANK_ACC_BIC: string,
    BANK_ACC_DETAILS: string,
    CREATED: number,
    VERSION: number,
    CONFIRMED: number,
}

export interface Withdraw {
    USER_ID: number,
    TYPE1: string,
    SPB_TEL: string,
    SPB_TEL_BANK_ID: number,
    CARD_NUMBER: string,
    ACCOUNT_NUMBER: string,
    BIC: string,
    CREATED: number,
    VERSION: number,
}

export interface Template {
    ID: number,
    USER_ID: number,
    NAME: string,
    TYPE1: string,
    CONTENT: string,
    CREATED: number,
    VERSION: number,
}

export type PayoutListType = "STANDARD";

export interface PayoutList {
    ID: number,
    TYPE1: PayoutListType,
    NAME: string,
    USER_ID: number,
    COMPANY_ID: number,
    DOCUMENT_ID: number,
    CREATED: number,
    VERSION: number,
    SENDED: number,
    CONFIRMED: number,
    PROCESSED: number,
}

export interface Payout {
    ID: number,
    PAYOUT_LIST_ID: number,
    USER_ID: number,
    EXECUTOR_CONTRACT_ID: number,
    EXECUTOR_TASK_ID: number,
    VALUE1: number,
    TAX: number,
    COMMISSION: number,
    FIO: string,
    CODE_INN: string,
    ADDITIONAL_INFO: string,
    WITHDRAW_TYPE1: string,
    WITHDRAW_SPB_TEL: string,
    WITHDRAW_SPB_TEL_BANK_ID: number,
    WITHDRAW_CARD_NUMBER: string,
    WITHDRAW_ACCOUNT_NUMBER: string,
    WITHDRAW_BIC: string,
    NALOG_ID: number,
    NALOG_REQ_ID: string,
    DOCUMENT_ID: number,
    CREATED: number,
    VERSION: number,
    SENDED: number,
    PROCESSED: number,
    REJECTED: number,
    TAX_PAID: number,
}

export interface Income {
    ID: number,
    USER_ID: number,
    TYPE1: string,
    FROM_USER_ID: number,
    PAYOUT_ID: number,
    VALUE1: number,
    EXTERNAL_ID: number,
    COMMENTS: string,
    CREATED: number,
}

export interface Expense {
    ID: number,
    USER_ID: number,
    TYPE1: string,
    TO_USER_ID: number,
    PAYOUT_ID: number,
    DOCUMENT_ID: number,
    VALUE1: number,
    EXTERNAL_ID: number,
    COMMENTS: string,
    CREATED: number,
    VERSION: number,
    CONFIRMED: number,
    REJECTED: number,
}

export const dataApi = {
    documentGet: async (id: number) => {
        const response = await axiosInstance.get<Data<Document>[]>(
            `/data/document/${id}`
        );
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    documentList: async (companyId: number | null, userId: number | null, type: "FROM" | "TO", offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("companyId", companyId ? String(companyId) : "-1");
        if (userId)
            params.append("userId", String(userId));
        params.append("type", type);
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<Document>[]>(`/data/document/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    documentListCount: async (companyId: number | null, userId: number | null, type: "FROM" | "TO") => {
        const params = new URLSearchParams();
        params.append("companyId", companyId ? String(companyId) : "-1");
        if (userId)
            params.append("userId", String(userId));
        params.append("type", type);
        const response = await axiosInstance.get<Data<OResult>[]>(`/data/document/list/count`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    documentCreateOrUpdate: async (id: number | null, toUserId: number, companyId: number | null, content: string, needConfirm: boolean) => {
        const params = new URLSearchParams();
        params.append("toUserId", String(toUserId));
        if (companyId)
            params.append("companyId", String(companyId));
        params.append("content", content);
        if (id)
            params.append("id", String(id));
        params.append("needConfirm", String(needConfirm));
        const response = await axiosInstance.post<Data<Document>[]>(`/data/document`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    documentReady: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/document/ready`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    documentSign: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<Document>[]>(`/data/document/sign`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    documentReject: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/document/reject`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    documentDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/document`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    documentFileList: async (documentId: number) => {
        const params = new URLSearchParams();
        params.append("documentId", String(documentId));
        const response = await axiosInstance.get<Data<DocumentFile>[]>(`/data/document/file/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    documentFileDataGet: (id: number, fileName?: string) =>
        axiosInstance.get(
            `/data/document/file/data/${id}`
            , {responseType: 'blob'})
            .then((response) => {
                downloadLinkProcessor(fileName ? fileName : `document_file_${id}.txt`, response);
            }),
    documentFileCreateOrUpdate: async (id: number | null, documentId: number, fileName: string, file: File) => {
        const formData = new FormData();
        formData.append("documentId", String(documentId));
        formData.append("fileName", fileName);
        formData.append("file", file);
        if (id)
            formData.append("fileId", String(id));
        const response = await axiosInstance.post<Data<DocumentFile>[]>(
            `/data/document/file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data;charset=UTF-8'
                }
            }
        );
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    documentFileDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/document/file`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    companyGet: async (id: number) => {
        const response = await axiosInstance.get<Data<Company>[]>(`/data/company/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    companyOwnGet: async () => {
        const response = await axiosInstance.get<Data<Company>[]>(`/data/company/own`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyReg: async (name: string, nameFull: string, address: string, addressActual: string, codeInn: string, codeKPP: string, codeOGRN: string, email: string, tel: string) => {
        const params = new URLSearchParams();
        params.append("name", name);
        params.append("nameFull", nameFull);
        params.append("address", address);
        params.append("addressActual", addressActual);
        params.append("codeInn", codeInn);
        params.append("codeKPP", codeKPP);
        params.append("codeOGRN", codeOGRN);
        params.append("email", email);
        params.append("tel", tel);
        const response = await axiosInstance.post<Data<Company>[]>(`/data/company/reg`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    companySave: async (id: number, address: string, addressActual: string, email: string, tel: string) => {
        const response = await axiosInstance.put<Data<Company>[]>(`/data/company`, {
            "id": id,
            "address": address,
            "addressActual": addressActual,
            "email": email,
            "tel": tel,
        });
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    companyForExecutorList: async (executorId: number) => {
        const params = new URLSearchParams();
        params.append("id", String(executorId));
        const response = await axiosInstance.get<Data<Company>[]>(`/data/company/forexecutor`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyForOperatorList: async (companyOperatorId: number) => {
        const params = new URLSearchParams();
        params.append("id", String(companyOperatorId));
        const response = await axiosInstance.get<Data<Company>[]>(`/data/company/foroperator`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyExecutorGet: async (id: number) => {
        const response = await axiosInstance.get<Data<CompanyExecutor>[]>(`/data/company/executor/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    companyExecutorList: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        params.append("full", "false");
        const response = await axiosInstance.get<Data<CompanyExecutor>[]>(`/data/company/executor/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyExecutorListByExecutor: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.get<Data<CompanyExecutor>[]>("/data/company/executor/list/byexecutor", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyExecutorListFull: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        params.append("full", "true");
        const response = await axiosInstance.get<Data<CompanyExecutorFull>[]>(`/data/company/executor/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorCompanyReg: async (companyId: number, executorId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        params.append("executorId", String(executorId));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/company/executor/reg`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    companyExecutorConfirm: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/company/executor/confirm`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorContractGet: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.get<Data<ExecutorContract>[]>(`/data/company/executor/contract`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorContractList: async (companyExecutorId: number) => {
        const params = new URLSearchParams();
        params.append("id", String(companyExecutorId));
        const response = await axiosInstance.get<Data<ExecutorContract>[]>(`/data/company/executor/contract/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorContractAdd: async (companyExecutorId: number, name: string, endDate: number) => {
        const params = new URLSearchParams();
        params.append("id", String(companyExecutorId));
        params.append("name", name);
        params.append("endDate", String(endDate));
        const response = await axiosInstance.post<Data<ExecutorContract>[]>(`/data/company/executor/contract`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorContractSave: async (id: number, name: string, endDate: number) => {
        const response = await axiosInstance.put<Data<OResult>[]>(`/data/company/executor/contract`, {
            "id": id,
            "name": name,
            "endDate": endDate
        });
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorContractSend: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/company/executor/contract/send`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorOwnGet: async () => {
        const response = await axiosInstance.get<Data<Executor>[]>(`/data/executor/own`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorGet: async (id: number) => {
        const response = await axiosInstance.get<Data<Executor>[]>(`/data/executor/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorReg: async (codeInn: string, firstName: string, secondName: string, lastName: string) => {
        const params = new URLSearchParams();
        params.append("codeInn", codeInn);
        params.append("firstName", firstName);
        params.append("secondName", secondName);
        params.append("lastName", lastName);
        const response = await axiosInstance.post<Data<Executor>[]>(`/data/executor/reg`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorCompanyJoin: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/executor/company/join`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorCompanyAccept: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/executor/company/accept`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorFindByInn: async (companyId: number, inn: string) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        params.append("inn", String(inn));
        const response = await axiosInstance.get<Data<Executor>[]>(`/data/executor/forinn`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    accountOwnGet: async () => {
        const response = await axiosInstance.get<Data<Account>[]>(`/data/account/own`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    accountGet: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<Account>[]>(`/data/account`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    withdrawGet: async (userId: number) => {
        const response = await axiosInstance.get<Data<Withdraw>[]>(`/data/withdraw/${userId}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    withdrawOwnGet: async () => {
        const response = await axiosInstance.get<Data<Withdraw>[]>(`/data/withdraw/own`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    withdrawSave: async (userId: number, type: string, spbTel: string, spbTelBankId: number, cardNumber: string, accountNumber: string, bic: string) => {
        const response = await axiosInstance.put<Data<OResult>[]>(`/data/withdraw`, {
            "userId": userId,
            "type": type,
            "spbTel": spbTel,
            "spbTelBankId": spbTelBankId,
            "cardNumber": cardNumber,
            "accountNumber": accountNumber,
            "bic": bic
        });
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    templateGet: async (id: number) => {
        const response = await axiosInstance.get<Data<Template>[]>(`/data/template/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    templateOwnList: async () => {
        const response = await axiosInstance.get<Data<Template>[]>(`/data/template/own/list`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    templateCreateOrUpdate: async (id: number | null, name: string, type: string, content: string) => {
        const params = new URLSearchParams();
        params.append("name", name);
        params.append("type", type);
        params.append("content", content);
        if (id)
            params.append("id", String(id));
        const response = await axiosInstance.post<Data<Template>[]>(`/data/template`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    templateDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/template`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    payoutListGet: async (id: number) => {
        const response = await axiosInstance.get<Data<PayoutList>[]>(`/data/payout/list/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    payoutListOwnList: async (companyId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<PayoutList>[]>(`/data/payout/list/own/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    payoutListOwnListCount: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<OResult>[]>(`/data/payout/list/own/list/count`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    payoutListCreateOrUpdate: async (id: number | null, name: string, type: "STANDARD", companyId: number) => {
        const params = new URLSearchParams();
        params.append("name", name);
        params.append("type", type);
        params.append("companyId", String(companyId));
        if (id)
            params.append("id", String(id));
        const response = await axiosInstance.post<Data<PayoutList>[]>(`/data/payout/list`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    payoutListConfirm: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>(`/data/payout/list/confirm`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    payoutListDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/payout/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    payoutGet: async (id: number) => {
        const response = await axiosInstance.get<Data<Payout>[]>(`/data/payout/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    payoutLst: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.get<Data<Payout>[]>(`/data/payout/lst`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    payoutLstListByExecutor: async (companyExecutorId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("companyExecutorId", String(companyExecutorId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<Payout>[]>("/data/payout/lst/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    payoutLstListCountByExecutor: async (companyExecutorId: number) => {
        const params = new URLSearchParams();
        params.append("companyExecutorId", String(companyExecutorId));
        const response = await axiosInstance.get<Data<OResult>[]>("/data/payout/lst/list/count", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    payoutCreateOrUpdate: async (id: number | null, sendValue: number, fio: string, codeInn: string, additionalInfo: string, withdrawType: string, withdrawSpbTel: string,
                                 withdrawSpbTelBankId: number, withdrawCardNumber: string, withdrawAccountNumber: string, withdrawBic: string, payoutListId: number,
                                 toUserId: number, executorContractId: number, executorTaskId: number) => {
        const params = new URLSearchParams();
        params.append("sendValue", String(sendValue));
        params.append("fio", fio);
        params.append("codeInn", codeInn);
        params.append("additionalInfo", additionalInfo);
        params.append("withdrawType", withdrawType);
        params.append("withdrawSpbTel", withdrawSpbTel);
        params.append("withdrawSpbTelBankId", String(withdrawSpbTelBankId));
        params.append("withdrawCardNumber", withdrawCardNumber);
        params.append("withdrawAccountNumber", withdrawAccountNumber);
        params.append("withdrawBic", withdrawBic);
        params.append("payoutListId", String(payoutListId));
        params.append("toUserId", String(toUserId));
        params.append("executorContractId", String(executorContractId));
        params.append("executorTaskId", String(executorTaskId));
        if (id)
            params.append("id", String(id));
        const response = await axiosInstance.post<Data<Payout>[]>(`/data/payout`, params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    payoutDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/payout`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    incomeList: async (offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<Income>[]>(`/data/income/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    incomeListCount: async () => {
        const response = await axiosInstance.get<Data<OResult>[]>(`/data/income/list/count`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    expenseList: async (offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<Expense>[]>(`/data/expense/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    expenseListCount: async () => {
        const response = await axiosInstance.get<Data<OResult>[]>(`/data/expense/list/count`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    executorTaskList: async (executorContractId: number, companyId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("executorContractId", String(executorContractId));
        params.append("companyId", String(companyId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<ExecutorTask>[]>("/data/company/executor/task/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorTaskListCount: async (executorContractId: number, companyId: number) => {
        const params = new URLSearchParams();
        params.append("executorContractId", String(executorContractId));
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<OResult>[]>("/data/company/executor/task/list/count", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    executorTaskListByCompany: async (companyId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<ExecutorTask>[]>("/data/company/executor/task/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorTaskListCountByCompany: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<OResult>[]>("/data/company/executor/task/list/count", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    executorTaskListByCompanyExecutor: async (companyExecutorId: number, companyId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("companyExecutorId", String(companyExecutorId));
        params.append("companyId", String(companyId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<ExecutorTask>[]>("/data/company/executor/task/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorTaskListCountByCompanyExecutor: async (companyExecutorId: number, companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyExecutorId", String(companyExecutorId));
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<OResult>[]>("/data/company/executor/task/list/count", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    executorTaskListByExecutor: async (executorId: number, offset: number, limit: number) => {
        const params = new URLSearchParams();
        params.append("executorId", String(executorId));
        params.append("offset", String(offset));
        params.append("limit", String(limit));
        const response = await axiosInstance.get<Data<ExecutorTask>[]>("/data/company/executor/task/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorTaskListCountByExecutor: async (executorId: number) => {
        const params = new URLSearchParams();
        params.append("executorId", String(executorId));
        const response = await axiosInstance.get<Data<OResult>[]>("/data/company/executor/task/list/count", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return resultData.result;
    },
    executorTaskGet: async (id: number) => {
        const response = await axiosInstance.get<Data<ExecutorTask>[]>(`/data/company/executor/task/${id}`);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorTaskForPayList: async (companyExecutorId: number) => {
        const params = new URLSearchParams();
        params.append("companyExecutorId", String(companyExecutorId));
        const response = await axiosInstance.get<Data<ExecutorTask>[]>("/data/company/executor/task/list/forpay", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    executorTaskCreateOrUpdate: async (id: number | null, executorContractId: number, companyExecutorId: number, type: string, name: string, description: string, address: string,
                                       startDate: number, endDate: number, value: number,
                                       category: string, project: string, comments: string, calculationType: string, calculationTimeHEstimated: number) => {
        const params = new URLSearchParams();
        params.append("executorContractId", String(executorContractId));
        params.append("companyExecutorId", String(companyExecutorId));
        params.append("type", type);
        params.append("name", name);
        params.append("description", description);
        params.append("address", address);
        params.append("startDate", String(startDate));
        params.append("endDate", String(endDate));
        params.append("value", String(value));
        params.append("category", category);
        params.append("project", project);
        params.append("comments", comments);
        params.append("calculationType", calculationType);
        params.append("calculationTimeHEstimated", String(calculationTimeHEstimated));
        if (id)
            params.append("id", String(id));
        const response = await axiosInstance.post<Data<ExecutorTask>[]>("/data/company/executor/task", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    executorTaskSend: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.post<Data<OResult>[]>("/data/company/executor/task/send", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorTaskExecute: async (id: number, calculationTimeHActual: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        params.append("calculationTimeHActual", String(calculationTimeHActual));
        const response = await axiosInstance.post<Data<OResult>[]>("/data/company/executor/task/execute", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorTaskConfirm: async (id: number, calculationTimeHVerified: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        params.append("calculationTimeHVerified", String(calculationTimeHVerified));
        const response = await axiosInstance.post<Data<OResult>[]>("/data/company/executor/task/confirm", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    executorTaskDelete: async (id: number) => {
        const params = new URLSearchParams();
        params.append("id", String(id));
        const response = await axiosInstance.delete<Data<OResult>[]>(`/data/company/executor/task`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    companyOperatorList: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<CompanyOperator>[]>("/data/company/operator/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyOperatorCreateOrUpdate: async (id: number | null, companyId: number, inn: string, role: string, userId: number | null) => {
        const params = new URLSearchParams();
        if (id)
            params.append("id", String(id));
        params.append("companyId", String(companyId));
        params.append("inn", inn);
        params.append("role", role);
        if (userId)
            params.append("userId", String(userId));
        const response = await axiosInstance.post<Data<CompanyOperator>[]>("/data/company/operator", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data[0];
    },
    operatorReg: async (inn: string) => {
        const params = new URLSearchParams();
        params.append("codeInn", inn);
        const response = await axiosInstance.post<Data<OResult>[]>("/data/operator/reg", params);
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        const resultData = response.data[0].data[0];
        return !!resultData.result;
    },
    operatorListOwn: async () => {
        const response = await axiosInstance.get<Data<CompanyOperator>[]>("/data/operator/list");
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyFileList: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<CompanyFile>[]>(`/data/company/file/list`, {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },
    companyFileDataGet: (id: number, fileName?: string) =>
        axiosInstance.get(
            `/data/company/file/data/${id}`
            , {responseType: 'blob'})
            .then((response) => {
                downloadLinkProcessor(fileName ? fileName : `company_file_${id}.txt`, response);
            }),
    usersOperatorReadyList: async (companyId: number) => {
        const params = new URLSearchParams();
        params.append("companyId", String(companyId));
        const response = await axiosInstance.get<Data<Profile>[]>("/data/operator/user/list", {params: params});
        if (!Array.isArray(response.data) || response.data[0].errorCode || !Array.isArray(response.data[0].data))
            throw new Error(response.data && response.data[0] && response.data[0].errorText ? response.data[0].errorText : "");
        return response.data[0].data;
    },

};
